export class Constants {
    static readonly NOT_APPLICABLE = 'N/A';

    static readonly STRING_EMPTY = '';
    
    static readonly X_BDPORTAL_SECRET_HEADER = 'x-bdportal-secret';
    static readonly X_BDPORTAL_SECRET_VALUE = 'cGhiYd1Lh5nqP178HqkCmto7jdMlsPr4h';
}